import React from 'react';
import './App.css';
// import Weather from './Weather';
import AppWeather from './modules/App/AppWeather';

export default function App() {
  return (
    // <div className="App">
    //   <Weather defaultCity="Lviv" />
    //   <header className="App-header"></header>
    // </div>
    <AppWeather />
  );
}
// export default function App() {
//   return (
// <div className="App">
//   <div className="container">
//     <Weather defaultCity="New York" />

//     <footer>
//       This project was coded by{' '}
//       <a href="#" target="_blank" rel="noopener noreferrer">
//         Mariia Panchenko
//       </a>{' '}
//       and is{' '}
//       <a
//         href="https://github.com/MariaPanchenko/weather-react-app1"
//         target="_blank"
//         rel="noopener noreferrer"
//       >
//         open-sourced on GitHub
//       </a>{' '}
//       and{' '}
//       <a
//         href="https://magical-puffpuff-db6754.netlify.app/"
//         target="_blank"
//         rel="noopener noreferrer"
//       >
//         hosted on Netlify
//       </a>
//     </footer>
//   </div>
// </div>
// );
// }

// export default App;
